import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Button from '@jd/jmtd/es/Button';
import { getLocale } from '@jd/jmtd/es/locale';
import { FormGroupContext } from '../FormGroup/context';
export default function FormGroupResetButton(props) {
  return /*#__PURE__*/React.createElement(FormGroupContext.Consumer, null, function (_ref) {
    var trackEvent = _ref.trackEvent,
        reset = _ref.reset,
        locale = _ref.locale;
    return /*#__PURE__*/React.createElement(Button, _extends({
      "data-event-name": "reset",
      onClick: function onClick() {
        reset();
        trackEvent('reset');
      },
      outline: true
    }, _objectSpread({
      children: getLocale(locale).common.reset
    }, props)));
  });
}